export enum INPUT_STRATEGY {
  EXCHANGE_STRATEGY = 'EXCHANGE_STRATEGY',
  TYPE_STRATEGY = 'TYPE_STRATEGY',
}

export enum INSTRUMENT_TYPE {
  FUND = 'fund',
  STOCK = 'stock',
  BOND = 'bond',
  CASH = 'cash',
  PROXY = 'proxy',
  ALT = 'alt',
}
